/**
 * 文案 / 多语言
 *
 * 当前阶段：原样返回传入字符串。
 * 后续如需多语言，在此文件内补充 locale、MESSAGE_MAP 等逻辑即可。
 */

/** 获取展示文案 */
export function t(text: string): string {
    return text;
}
